<template>
    <job-list-shared
        :data="data"
        :is-loading="isLoading"
        :is-filtered="isFiltered"
        base-link-url="/jobs/assembling"
        @clear-filter="$emit('clear-filter', $event)">

        <template slot="column-infos" slot-scope="{ cl, job }">
            <div :class="cl('manager')">
                <small>Projektleiter</small>
                
                <p :class="cl('manager__contact')">
                    {{ job.manager.profile.firstname + ' ' + job.manager.profile.lastname }} <br />
                    <a v-if="job.manager.profile.tel_office || job.manager.profile.tel_mobile" :href="'tel:' + (job.manager.profile.tel_office || job.manager.profile.tel_mobile)">
                        {{ job.manager.profile.tel_office || job.manager.profile.tel_mobile }}
                    </a>
                    <a v-else-if="job.manager.profile.email" :href="`mailto:${job.manager.profile.email}`">
                        {{ job.manager.profile.email }}
                    </a>
                </p>
            </div>
        </template>

        <template slot="button-status-0">
            <button 
                type="button" 
                class="btn btn-secondary default-hover"
                disabled>
                
                Warte auf Bestätigung..
            </button>
        </template>

        <template slot="button-status-10" slot-scope="{ job }">
            <template v-if="job.dates.every(p => !p.technicianRequest || p.technicianRequest.validUntil < (new Date()))">
                <p class="text-right">
                    <strong>Annahmefrist abgelaufen</strong>
                </p>
            </template>

            <template v-else>
                <div v-for="jobDatesin in job.dates_filter" :key="jobDatesin.id">
                    <div>
                        <small>Annahmefrist endet {{ validUntilOutput(jobDatesin.technicianRequest.validUntil) }}</small>

                        <div class="d-flex approve-btn">
                            <button 
                                type="button" 
                                class="btn btn-icon btn-auto-width btn-next default-hover flex-fill mr-xxs" 
                                @click="showJobRequestRespondWindow($event, job, 2)">
                                
                                <img src="~smartdoors-shared/img/icons/check-circle-white.svg" />
                            </button>
                            <button 
                                type="button" 
                                class="btn btn-icon btn-auto-width btn-deny default-hover flex-fill mr-xxs" 
                                @click="showJobRequestRespondWindow($event, job, 3)">
                                
                                <img src="~smartdoors-shared/img/icons/cross-circle-white.svg" />
                            </button>
                        </div>
                    </div>
                </div>
                
            </template>
        </template>

        <!-- Pass all slots down to the base job-list -->
        <template v-for="(_, name) in $slots" >
            <slot v-if="name != 'default'" :name="name" :slot="name" />
        </template>
        <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="slotData">
            <slot v-if="name != 'default'" :name="name" v-bind="slotData" />
        </template>
    </job-list-shared>
</template>

<script>
import JobList from 'smartdoors-shared/js/components/Jobs/JobList';
import JobRequestRespondWindow from '../../windows/JobRequestRespond';
import { requestValidUntilOutput } from '../../helper/jobs';
import ShowsJobDateItems from '../../mixins/ShowsJobDateItems';

export default {
    mixins: [ ShowsJobDateItems ],
    components: {
        'job-list-shared': JobList
    },
    data() {
        return {
            firstValidDate: 0,
        };
    },
    props: {
        data: {
            type: Array,
            default() {
                return [];
            }
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        isFiltered: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        validUntilOutput(job) {
            return requestValidUntilOutput(job);
        },
        showJobRequestRespondWindow($event, job, status) {
            this.$windows.showWindow(JobRequestRespondWindow, { job, status }, {}, { triggerElement: $event.target }); 
        }
    }
}
</script>